import { makeAbsoluteUrl } from "../utils/Helper";

export const openWhatsAppLink = (e, phoneNumber, textMessage) => {
  e.preventDefault()
  const isMobile = /iPhone|Android|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const encodedText = encodeURIComponent(textMessage);
  const link = isMobile
    ? `https://wa.me/${phoneNumber.replace("+", "")}?text=${encodedText}`
    : `https://web.whatsapp.com/send?phone=${phoneNumber.replace("+", "")}&text=${encodedText}`;

  // Create an <a> element and simulate a click
  const a = document.createElement('a');
  a.href = link;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.click();
};

export const openCallAppLink = (e, phoneNumber) => {
  e.preventDefault()

  const link = `tel:${phoneNumber}`;

  // Create an <a> element and simulate a click
  const a = document.createElement('a');
  a.href = link;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.click();
};

export const openWindow = (link) => {
  // e.preventDefault()
  const a = document.createElement('a');
  a.href = makeAbsoluteUrl(link);
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.click();
}